<template>
  <div>
    <Modal
      v-model="visible"
      :mask-closable="false"
      title="导入"
      :footer-hide="true"
      width="550"
      class="my-modal top p-b"
    >
      <div class="import-container">
        <span class="title">操作步骤：</span>
        <div class="import-tips">
          <span>1、点击“续保导入模板”按钮</span>
          <span>2、根据模板中的提示，将批量导入续期数据整理至模板中</span>
          <span>3、点击“上传excel”，将整理好的excel确认上传</span>
          <span>4、如存在导入异常记录，请及时处理</span>
        </div>
      </div>

      <div class="action-buttom">
        <Button class="cancel" @click="visible = false">取消</Button>
        <div class="download-button" @click="feeImportTemplate">
            <img src="@/assets/images/icon/org/download.png">
            <span>续保导入模板</span>
          </div>
        <Upload action :before-upload="uploadExecl">
          <div class="download-button">
            <img src="@/assets/images/icon/org/upload.png">
            <span>上传Excel</span>
          </div>
        </Upload>
      </div>
    </Modal>

    <!-- 更新异常 -->
    <update-abnormal ref="updateAbnormal" :getInsureList='getInsureList'></update-abnormal>
  </div>
</template>

<script>
import updateAbnormal from "./updateAbnormal";

export default {
  components:{
    updateAbnormal
  },
  props:['getInsureList'],
  data() {
    return {
      visible: false,
    };
  },

  methods: {
    open() {
      this.visible = true;
    },

    // 将url转成blob文件
    getBlob(url) {
      return new Promise(resolve => {
        const xhr = new XMLHttpRequest()
        xhr.open('GET', url, true)
        xhr.responseType = 'blob'
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response)
          }
        }
        xhr.send()
      })
    },

    //下载文件 　　js模拟点击a标签进行下载
    saveAs(blob, filename) {
      var link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
    },

    // 续保导入模板
    feeImportTemplate() {
      this.$http({
        url: "/system/dic/read/dicList",
        type: "POST",
        data: {
          code: "RENEWAL_SHORT_EXPORT",
        },
      }).then((res) => {
        const url = res.data[0].value;
        const fileName = res.data[0].txt;
        this.getBlob(url).then(blob => {
          this.saveAs(blob, fileName);
        })
      });
    },

    // 上传Excel
    uploadExecl(file) {
      if (!/\.(xls|xlsx)$/.test(file.name.toLowerCase())) {
        this.$Message.error("请上传格式为xls或xlsx的文件");
        return false;
      }
      let formData = new FormData();
      formData.append("file", file);
      this.$http({
        url: "/buz/policyShortRenewalRecord/batch/upload",
        type: "POST",
        data: formData,
        apiPermissionCode:'renewalManage_01_1'
      }).then((res) => {
        if(res.data.noPolicy == "0" && res.data.abnormal == "0") {
          this.$Message.success("上传成功");
          this.visible = false;
        }else{
          this.$refs.updateAbnormal.open();
        }
      });
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.import-container {
  padding: 10px 10px;
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #272933;
  }
  .import-tips {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    line-height: 40px;
    font-size: 14px;
    color: #3c464f;
  }
}
.action-buttom {
  margin-top: 20px;
  padding: 0 10px 5px 10px;
  display: flex;
  justify-content: space-between;
  Button {
    width: 140px;
    height: 36px;
  }
  .cancel {
    width: 120px;
    border-color: #236dff;
    color: #236dff;
  }
  .download-button {
    width: 140px;
    height: 36px;
    background: #236DFF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-size: 14px;
      color: #fff;
      margin-left: 5px;
      margin-top: 2px;
    }
  }
  .download-button:hover {
    cursor: pointer;
  }
}
</style>